import { schema } from "normalizr";

const label = new schema.Entity(`labels`);
const arrayOfLabels = [label];

export { label, arrayOfLabels };
